export class BillableMoovDataReport {
    private moovCount = 0;
    private recordCount = 0;
    private completedAt!: string;

    

    public setRecordCount(value: number) {
        this.recordCount += value;
    }

    public getRecordCount() {
        return this.recordCount;
    }

    public setMoovCount(value: number) {
        this.moovCount += value;
    }

    public getMoovCount() {
        return this.moovCount;
    }

    public setCompletedAt(date: string) {
        this.completedAt = date;
    }

    public getCompletedAt() {
        return this.completedAt;
    }
}